export default __webpack_public_path__ + "static/comcom-low-a207e8fe0d5e080c689b848bccab8a94.gif";